import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';
import { EntityId } from '@reduxjs/toolkit';

export const generateDialogMemberId = (model: DialogMemberViewModel): EntityId => model.id;
